import { createSelector } from 'reselect'

export const selectAccountPortalRoot = (state) => state.bootup.accountPortalRoot
export const selectAuthToken = (state) => state.bootup.authToken
export const selectAppConfig = (state) => state.bootup && state.bootup.appConfig
export const selectCustomerSupportEmail = (state) => state.bootup.customerSupportEmail
export const selectCustomerSupportLink = (state) => state.bootup.customerSupportLink
export const selectExportDataLink = (state) => state.bootup.exportDataLink
export const selectPremiumUpsellURL = (state) => state.bootup.premiumUpsellURL
export const selectPremiumStripeKey = (state) => state.bootup.premiumStripeKey
export const selectMapmyVersion = (state) => state.bootup.mapmyVersion
export const selectMessages = (state) => state.bootup.messages
export const selectLanguage = (state) => state.bootup.language
export const selectShouldRenderAds = (state) => state.bootup.shouldRenderAds
export const selectWechatApiConfig = (state) => state.bootup.wechatApiConfig

export const selectLanguageCode = createSelector(
  selectLanguage,
  (language) => language && language.code
)

export const selectHasPremium = createSelector(
  selectAppConfig,
  (appConfig) => appConfig && appConfig.unlockPremium
)
